import type { ReactElement, ReactNode } from 'react'

import { Trans } from '@lingui/react'
import { isNil } from 'ramda'

import { Container } from '@twisto/components/atoms/container'
import {
  FormattedCurrencyNumber,
  FormattedNumber,
} from '@twisto/components/atoms/format'
import { Typography } from '@twisto/components/atoms/typography'

import * as styles from './installment-offer-schedule-table.styles'
import { InstallmentsOfferScheduleTableHeader } from './installments-offer-schedule-table-header'
import { Row } from './row'

type Props = {
  deferVariant?: boolean
  hideAmountPerPeriod?: boolean
  variant: 'grayBackground' | 'borderedBox'
  annualPercentageRate: string
  amountPerPeriod: string
  extraAmount: string
  periodsCount: number
  principalAmount: string
  totalAmount: string
  title?: ReactNode
  footer?: ReactElement
}
export const InstallmentOfferScheduleTable = ({
  deferVariant = false,
  hideAmountPerPeriod = false,
  variant,
  extraAmount,
  annualPercentageRate,
  principalAmount,
  amountPerPeriod,
  periodsCount,
  totalAmount,
  title,
  footer,
}: Props) => (
  <div
    css={[variant === 'grayBackground' && styles.grayBackgroundVariant]}
    data-testid="installment-offer"
  >
    <Container
      noPadding
      css={variant === 'borderedBox' && styles.borderedBoxVariant}
      size="tiny"
    >
      {!isNil(title) && (
        <Typography align="center" fontWeight="medium" variant="h3">
          {title}
        </Typography>
      )}
      {!hideAmountPerPeriod && (
        <InstallmentsOfferScheduleTableHeader
          amountPerPeriod={amountPerPeriod}
          periodsCount={periodsCount}
        />
      )}

      <Row endAdornment={<FormattedCurrencyNumber value={principalAmount} />}>
        <Trans id="flow.components.installmentOfferScheduleTable.field.orderAmount" />
      </Row>
      <Row endAdornment={<FormattedCurrencyNumber value={extraAmount} />}>
        <Trans id="flow.components.installmentOfferScheduleTable.field.extraPay" />
      </Row>
      {!deferVariant && (
        <>
          <Row
            endAdornment={
              <FormattedNumber style="percent" value={annualPercentageRate} />
            }
          >
            <Trans id="flow.components.installmentOfferScheduleTable.field.apr" />
          </Row>
          <Row endAdornment={<FormattedCurrencyNumber value={totalAmount} />}>
            <Trans id="flow.components.installmentOfferScheduleTable.field.totalAmount" />
          </Row>
        </>
      )}

      {footer}
    </Container>
  </div>
)
